<template>
   <div class="row">
      <div id="search-nav" class="col-12 d-block btn-group dropup">
         <button type="button" class="btn btn-primary dropdown-toggle d-block d-lg-none rounded" :class="pesquisa.resultado.length > 0 ? '' : 'empty'" data-toggle="dropdown" aria-expanded="false">
            <i class="far fa-search font-17"></i>
         </button>
         <div class="card mb-2 dropdown-menu dropdown-menu-left">
            <div class="card-body pb-0">
               <div class="row m-0">
                  <div class="col-12 col-sm-6 col-md-2 mb-3 px-1">
                     <label><i class="far fa-filter font-13 color-theme mr-1"></i> Tipo de pesquisa</label>
                     <v-select class="rounded" title="Desktop" :options="['Nome completo', 'CPF/CNPJ', 'RG']" v-model="pesquisa.tipo" />
                     <select title="Mobile" class="form-control rounded" v-model="pesquisa.tipo">
                        <option v-for="(option, index) in ['Nome completo', 'CPF/CNPJ', 'RG']" :key="index" :value="option">{{ option }}</option>
                     </select>
                  </div>
                  <div class="col-12 col-sm-6 col-md-7 mb-3 px-1">
                     <label v-if="pesquisa.tipo == 'Nome completo'"><i class="far fa-user font-13 color-theme mr-1"></i> Nome completo</label>
                     <label v-else-if="pesquisa.tipo == 'RG'"><i class="far fa-id-card-alt font-13 color-theme mr-1"></i> RG</label>
                     <label v-else-if="pesquisa.tipo == 'CPF/CNPJ'"><i class="far fa-address-card font-13 color-theme mr-1"></i> CPF/CNPJ</label>
                     <input type="text" class="form-control rounded" v-model="pesquisa.valor" maxlength="200" @keyup.enter="buscarUsuarios" placeholder="Busque por nome completo, CPF ou RG" />
                  </div>
                  <div class="col-5 col-sm-6 col-md-1 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="buscarUsuarios">
                        <i class="fa fa-search font-13"></i>
                     </button>
                  </div>
                  <div class="col-7 col-sm-6 col-md-2 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="abrirAddUsuario">
                        <i class="fa fa-plus font-13 mr-1"></i> Adicionar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <!-- listaUsuarios  -->
      <div class="col-12" v-if="pesquisa.resultado.length > 0">
			<div class="card mb-0">
				<div class="card-body">
					<div class="row px-1">
						<div class="col mb-2 align-self-center">
							<div class="limitador-1 mb-1"><i class="fas fa-angle-right color-theme me-1"></i> {{ pesquisa.resultado.length == 100 ? 'Limitado a ': '' }} {{ pesquisa.resultado.length }} resultado(s)</div>
						</div>
					</div>
               <div class="cards-2">
                  <usuario v-for="(user, index) in pesquisa.resultado" :key="index" :user="user" :index="index" @editar="abrirEditarUsuario($event)" @senha="abrirEditarSenha($event)" />
               </div>
				</div>
			</div>
      </div>
      <div class="col-12 my-5 text-center" v-else>Nenhum resultado encontrado</div>

      <!-- modalUsuario -->
      <div class="modal fade" id="modalUsuario" tabindex="-1" aria-labelledby="modalUsuarioLabel" aria-hidden="true">
         <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalUsuarioLabel" v-if="modal != null && modal.id != null">Editar usuário</h5>
                  <h5 class="modal-title h4" id="modalUsuarioLabel" v-else>Adicionar usuário</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body" v-if="modal != null">
                  <div class="row m-0">
                     <div class="col-xl-6 px-1 mb-2">
                        <div class="card mb-0">
                           <div class="card-body" id="add_user_step1">
                              <div class="row m-0">
                                 <div class="col-12 px-1 mb-1">
                                    <h6 class="text-center mb-0">Informações do usuário</h6>
                                    <hr class="mb-2">
                                 </div>
                                 <div class="col-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-envelope color-theme font-13 mr-1"></i> Email *</label>
                                    <input type="email" class="form-control rounded" maxlength="200" v-model="modal.login" />
                                 </div>
                                 <div class="col-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-venus-mars color-theme font-13 mr-1"></i> Sexo *</label>
                                    <v-select class="rounded" title="Desktop" :options="['Masculino', 'Feminino', 'Outros']" v-model="modal.sexo" placeholder="Selecione um sexo" />
                                    <select title="Mobile" class="form-control rounded" v-model="modal.sexo">
                                       <option v-for="(option, index) in ['Masculino', 'Feminino', 'Outros']" :key="index" :value="option">{{ option }}</option>
                                    </select>
                                 </div>
                                 <div class="col-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-user color-theme font-13 mr-1"></i> Nome completo *</label>
                                    <input type="text" class="form-control rounded" maxlength="200" v-model="modal.nomeCompleto" />
                                 </div>
                                 <div class="col-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-address-card color-theme font-13 mr-1"></i> CPF/CNPJ *</label>
                                    <input type="text" class="form-control rounded" v-model="modal.cpf" v-mask="['###.###.###-##', '##.###.###/####-##']" />
                                 </div>
                                 <div class="col-12 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-calendar color-theme font-13 mr-1"></i> Data de nascimento</label>
                                    <input type="text" class="form-control rounded" v-model="modal.dataNascimento" v-mask="'##/##/####'" />
                                 </div>
                                 <div class="col-12 px-1">
                                    <label class="mb-1"><i class="far fa-address-card color-theme font-13 mr-1"></i> RG</label>
                                    <input type="text" class="form-control rounded" maxlength="20" v-model="modal.rg" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div class="col-xl-6 px-1">
                        <div class="card mb-0">
                           <div class="card-body" id="add_user_step2">
                              <div class="col-12 px-1 mb-1">
                                 <h6 class="text-center mb-0">Permissões</h6>
                                 <hr class="mb-2">
                              </div>
                                 
                              <div class="row m-0">
                                 <permissao v-for="(permissao, index) in modal.permissoes" :key="index" :permissao="permissao" @toggle="togglePermissao($event)" />
                                 <div class="col-12 px-1 py-4 text-center" v-if="modal.permissoes == null || modal.permissoes.length == 0">Nenhuma permissão encontrada</div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>
               <div class="modal-footer">
                  <button id="add_user_step3" type="button" class="btn btn-round btn-primary" @click="salvarUsuario">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <!-- modalSenha -->
      <div class="modal fade" id="modalSenha" tabindex="-1" aria-labelledby="modalSenhaLabel" aria-hidden="true">
         <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalSenhaLabel">Editar senha</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body" v-if="modal != null">
                  <div class="card mb-0">
                     <div class="card-body">
                        <div class="row m-0">
                           <div class="col-12 px-1 mb-3">
                              <label class="mb-1"><i class="far fa-lock color-theme font-13 mr-1"></i> Nova senha</label>
                              <input type="text" class="form-control rounded key" maxlength="200" v-model="modal.senha" />
                           </div>
                           <div class="col-12 px-1">
                              <label class="mb-1"><i class="far fa-lock color-theme font-13 mr-1"></i> Repetir senha</label>
                              <input type="text" class="form-control rounded key" maxlength="200" v-model="modal.novaSenha" @keyup.enter="salvarSenha" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="salvarSenha">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>

import $ from 'jquery'
import { mapState } from 'vuex'
import usuario from '@/components/usuarios/Usuario.vue'
import permissao from '@/components/usuarios/Permissao.vue'

export default {
	name: 'Usuários',
   data: function () {
      return {
         pesquisa: {'tipo': 'Nome completo', 'rg': null, 'valor': null, 'cpf': null, 'resultado': []},
         modal: {'id': null, 'login': null, 'senha': null, 'novaSenha': null, 'nomeCompleto': null, 'dataNascimento': null, 'sexo': 'Outros', 'rg': null, 'cpf': null, 'permissoes': []}
      }
   },
   computed: {
      ... mapState({
         listaPermissoes: state => state.listaPermissoes,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   components: {
      usuario, permissao
   },
   methods: {
      buscarUsuarios() {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.pesquisa.resultado = [];

         this.$axios({
            method: 'get',
            url: this.urlRest +'usuarios/searchUsuarios',
            params: {
               tipo: this.pesquisa.tipo,
               valor: this.pesquisa.valor
            }
         }).then(response => {
				this.pesquisa.resultado = response.data

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      abrirEditarSenha(idUsuario) {
         this.modal = {'id': idUsuario, 'login': null, 'senha': null, 'novaSenha': null, 'nomeCompleto': null, 'dataNascimento': null, 'sexo': null, 'rg': null, 'cpf': null, 'permissoes': []}

         setTimeout(() => {
            $('#modalSenha').modal('show')
         }, 100);
      },
      abrirAddUsuario() {
         this.modal = {'id': null, 'login': null, 'senha': null, 'novaSenha': null, 'nomeCompleto': null, 'dataNascimento': null, 
            'sexo': 'Outros', 'rg': null, 'cpf': null, 'permissoes': this.listaPermissoes
         }

         $('#modalUsuario').modal('show')

         //tourTutorial
         setTimeout(() => {
            if (localStorage.getItem('tour_add_user') !== 'ok' && window.innerWidth > 1200) {
               // this.startTour();
            }
         }, 500);

      },
      abrirEditarUsuario(idUsuario) {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'get',
            url: this.urlRest +'usuarios/getUsuarioInfo',
            params: {
               id: idUsuario
            }
         }).then(response => {
				this.modal = response.data;
            this.modal.dataNascimento = this.modal.dataNascimento != null ? new Date(this.modal.dataNascimento.year +'/'+ this.modal.dataNascimento.monthValue +'/'+ this.modal.dataNascimento.dayOfMonth).toLocaleDateString() : null;

            setTimeout(() => {
               $('#modalUsuario').modal('show')
            }, 100);
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      togglePermissao(idPermissao) {
         this.modal.permissoes.forEach(permissao => {
            if (permissao.id == idPermissao) {
               permissao.habilitado = !permissao.habilitado
            }
         });
      },
      salvarUsuario() {
         if (this.modal.login == null || this.modal.login.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Email inválido!'
            })

            return
         } else if (this.modal.sexo == null) {
            this.$toast.fire({
               icon: 'error',
               title: 'Sexo inválida!'
            })

            return
         } else if (this.modal.nomeCompleto == null || this.modal.nomeCompleto.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Nome inválido!'
            })

            return
         } else if (this.modal.cpf == null || this.modal.cpf.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'CPF/CNPJ inválido!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'usuarios/saveUsuario',
            headers: {
					'Content-Type': 'application/json'
            },
				data: this.modal

         }).then(function () {
				$('#modalUsuario').modal('hide')

            if (ref.modal.id == null) {
               ref.pesquisa.tipo = 'Nome completo'
               ref.pesquisa.valor = ref.modal.nomeCompleto
            }
         
            ref.buscarUsuarios()

            ref.$toast.fire({
               icon: 'success',
               title: 'Usuário salvo!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 409) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Email já existente!'
                  });
               } else if (error.response.status == 403) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'CPF/CNPJ já existente!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Data de nascimento inválida!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      salvarSenha() {
         if (this.modal.senha == null || (this.modal.senha.trim().length > 0 && this.modal.senha.trim().length < 4)) {
            this.$toast.fire({
               icon: 'error',
               title: 'Senha deve ter 4 caracteres!'
            })

            return
         } else if (this.modal.senha.trim() != this.modal.novaSenha.trim()) {
            this.$toast.fire({
               icon: 'error',
               title: 'Senhas direfentes!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'usuarios/changePassword',
				params: {
               idUsuario: this.modal.id,
               senha: this.modal.senha
            }
         }).then(function () {
				$('#modalSenha').modal('hide')

            ref.$toast.fire({
               icon: 'success',
               title: 'Senha salva!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      startTour() {
			const steps = [];

			steps.push({
            element: '#add_user_step1',
            intro: 'Adicione informações básicas do usuário.'
         });

         steps.push({
            element: '#add_user_step2',
            intro: 'Determine as permissões que esse usuário terá no sistema.'
         });

         steps.push({
            element: '#add_user_step3',
            intro: 'Lembre-se de salvar as informações antes de sair da tela.'
         });

			// Inicia o tour com os steps filtrados
			this.$intro().setOptions({
				steps
			}).start();

			localStorage.setItem('tour_add_user', 'ok')
		}
   },
   mounted() {
      this.$store.dispatch('buscarPermissoes')

      $('#search-nav .dropdown-menu').on('click', function(e) {
         if (e.target.nodeName != 'BUTTON') {
            e.stopPropagation();
         }
      });

      this.buscarUsuarios()
   }
}

</script>

<style>

</style>